module.exports = __webpack_public_path__ + "media/images/social-icons/instagram-white-5fc1d376461bddb54c77c54f1ee47e07.svg";